import { MapPin, ShieldCheck, Award } from "lucide-react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HeroValueBar from "@/components/HeroValueBar";
import FeaturesBar from "@/components/FeaturesBar";
import AboutSection from "@/components/AboutSection";
import HomeReviewsStrip from "@/components/HomeReviewsStrip";
import RoomsSection from "@/components/RoomsSection";
import SoulSafariSection from "@/components/SoulSafariSection";
import ExperiencesSection from "@/components/ExperiencesSection";
import BookingCTA from "@/components/BookingCTA";
import FastFacts from "@/components/FastFacts";
import Footer from "@/components/Footer";
import StickyBookingBar from "@/components/StickyBookingBar";
import CookieConsent from "@/components/CookieConsent";
import SpecialOffersPopup from "@/components/SpecialOffersPopup";
import SEO from "@/components/SEO";
import JsonLd from "@/components/JsonLd";

import heroImg from "@/assets/hero-caracal.webp";

const heroValueItems = [
  { icon: MapPin, label: "2 hrs from Johannesburg" },
  { icon: ShieldCheck, label: "Malaria-free " },
  { icon: Award, label: "TripAdvisor Hall of Fame" },
];

const SITE_URL = typeof window !== "undefined" ? window.location.origin : "https://www.zwahili.co.za";

const lodgingSchema = {
  "@context": "https://schema.org",
  "@type": ["LodgingBusiness", "Hotel"],
  "@id": `${SITE_URL}/#lodge`,
  name: "Zwahili Private Game Lodge & Spa",
  description:
    "Luxury malaria-free game lodge and spa in the Limpopo bushveld — a 2-hour drive from Johannesburg. Ten rooms and suites, gourmet boma dining, an African spa and guided game drives and bush walks, for a maximum of 20 guests.",
  url: SITE_URL,
  image: `${SITE_URL}${heroImg}`,
  telephone: "+27-12-362-0681",
  email: "reservations@zgl.co.za",
  priceRange: "$$$",
  currenciesAccepted: "ZAR",
  paymentAccepted: "Cash, Credit Card",
  petsAllowed: false,
  starRating: { "@type": "Rating", ratingValue: "4" },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Mookgophong (Naboomspruit)",
    addressLocality: "Mookgophong",
    addressRegion: "Limpopo",
    postalCode: "0560",
    addressCountry: "ZA",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: -24.789167,
    longitude: 28.738611,
  },
  hasMap:
    "https://maps.app.goo.gl/txHuHfBjksCX6L2b7",
  amenityFeature: [
    { "@type": "LocationFeatureSpecification", name: "Free WiFi", value: true },
    { "@type": "LocationFeatureSpecification", name: "Swimming Pool", value: true },
    { "@type": "LocationFeatureSpecification", name: "Spa", value: true },
    { "@type": "LocationFeatureSpecification", name: "Restaurant", value: true },
    { "@type": "LocationFeatureSpecification", name: "Game Drives", value: true },
    { "@type": "LocationFeatureSpecification", name: "Helipad", value: true },
    { "@type": "LocationFeatureSpecification", name: "Boma", value: true },
    { "@type": "LocationFeatureSpecification", name: "Malaria-free", value: true },
  ],
  sameAs: [
    "https://www.facebook.com/ZwahiliGameLodge",
    "https://www.instagram.com/zwahiligamelodge",
    "https://www.youtube.com/@zwahiligamelodge",
    "https://www.linkedin.com/company/zwahili-game-lodge",
    "https://www.tripadvisor.com/Hotel_Review-g12247498-d1220498-Reviews-Zwahili_Game_Lodge_Spa-Mookgophong_Naboomspruit_Limpopo_Province.html",
  ],
  award: [
    "TripAdvisor Hall of Fame",
    "TripAdvisor Travelers' Choice 2025",
    "BirdLife Birder Friendly",
  ],
};

const Index = () => {

  return (
    <div className="min-h-screen bg-background pb-14">
      <SEO
        title="Zwahili Private Game Lodge & Spa | Malaria-Free Safari Limpopo"
        description="Zwahili Private Game Lodge & Spa — a luxury malaria-free game lodge in Limpopo, 2 hours from Johannesburg. 10 suites, game drives, boma dining & spa. View rates & offers."
        image={heroImg}
        imageAlt="Zwahili Private Game Lodge & Spa luxury bushveld retreat in the Limpopo Province"
        canonical="https://www.zwahili.co.za/"
      />
      <JsonLd id="lodge" data={lodgingSchema} />
      <Navbar />
      <HeroSection />
      <HeroValueBar items={heroValueItems} />
      <FeaturesBar />
      <AboutSection />
      <HomeReviewsStrip />
      <RoomsSection />
      <SoulSafariSection />
      <ExperiencesSection />
      <BookingCTA />
      <FastFacts />
      <Footer />
      <StickyBookingBar />
      <CookieConsent />
      <SpecialOffersPopup />
    </div>
  );
};

export default Index;
